import React from 'react';
import { APP_CONFIG } from '../../../utils/constants';
import appStoreBadge from '../../../images/black.svg';
import styles from './AppStoreButton.module.css';

const AppStoreButton = ({ className = '' }) => {
  return (
    <a 
      href={APP_CONFIG.appStoreUrl}
      target="_blank" 
      rel="noopener noreferrer"
      className={`${styles.imageButton} ${className}`}
    >
      <img 
        src={appStoreBadge} 
        alt="Download on the App Store" 
        className={styles.badgeImage}
      />
    </a>
  );
};

export default AppStoreButton;